import { Wallet, Calculator, BarChart3, Briefcase, Users, ClipboardList, Megaphone, TrendingUp, Scale, ShieldCheck, ListChecks } from "lucide-react";

export const CATEGORY_ICONS = {
  payroll: Wallet,
  accounting: Calculator,
  data: BarChart3,
  admin: Briefcase,
  hr: Users,
  operations: ClipboardList,
  marketing: Megaphone,
  sales: TrendingUp,
  legal: Scale,
  it: ShieldCheck,
  projects: ListChecks,
};

export const iconFor = (key) => CATEGORY_ICONS[key] || Briefcase;
